import { makeStyles } from '@fluentui/react-components';

export const usePaginationBarStyles = makeStyles({
    item: {
        '& > button': {
            minWidth: '32px',
        },
    },
    ellipsis: {
        display: 'flex',
        alignItems: 'center',
    },
});
